<template>
  <HgModal
    v-model="showOverlay"
    :containerCssClass="$style.modalContainer"
    data-testid="insights-hub-release-overlay"
    @close="close"
  >
    <template #title>{{ t('listing_insights_overlay.title') }}</template>

    <template #default>
      <img
        v-if="imageUrl"
        :src="imageUrl"
        :alt="t('listing_insights_overlay.title')"
        :class="$style.image"
        data-testid="insights-hub-release-overlay-image"
      />
      <p :class="$style.text" data-testid="insights-hub-release-overlay-text">
        {{ t('listing_insights_overlay.text') }}
      </p>
    </template>

    <template #footer>
      <HgButton
        theme="primary"
        data-testid="insights-hub-release-overlay-cta"
        @click="goToInsightsHub"
      >
        {{ t('listing_insights_overlay.cta') }}
      </HgButton>
    </template>
  </HgModal>
</template>

<script setup lang="ts">
import { HgButton, HgModal, HgSupportedLanguage } from '@smg-real-estate/domus';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import { resolveWhatsNewImage } from '@/views/WhatsNewPage/resolveWhatsNewImage';

const LOCAL_STORAGE_KEY = 'insightsHubReleaseOverlayShown';

const route = useRoute();
const router = useRouter();
const { t, locale } = useI18n();

const showOverlay = ref(false);

const imageUrl = computed(() =>
  resolveWhatsNewImage('Listing_Insights', locale.value as HgSupportedLanguage),
);

onMounted(() => {
  if (!localStorage.getItem(LOCAL_STORAGE_KEY)) {
    nextTick(() => (showOverlay.value = true));
  }
});

const dismiss = () => {
  localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
  showOverlay.value = false;
};

const close = () => {
  dismiss();
};

const goToInsightsHub = () => {
  dismiss();
  router.push({
    name: 'listing-insights',
    params: { ...route.params, locale: route.params.locale },
  });
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.modalContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-y: auto;

  @media (min-width: $viewport-sm-min) {
    width: auto;
    max-width: 600px;
    height: auto;
  }
}

.image {
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: $space-150;
}

.text {
  padding: 0 $space-150 $space-150;
  margin: 0;
  color: $color-grey-90;

  @include body-3;
}
</style>
